import { Session } from '@shared/app/scripts/services/session';
import { Navigate } from '@core/app/scripts/services/navigate';
import { NotificationManager } from '@shared/app/scripts/services/notification-manager';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { SessionManager } from '@shared/app/scripts/services/session-manager';

import { map } from 'rxjs/operators';

/**
 * Component responsible for /choose-tenant route.
 */
angular.module('gateApp').component('chooseTenant', {
  template: require('./choose-tenant.html').default,
  controller: function (
    $q: ng.IQService,
    $timeout: ng.ITimeoutService,
    $translate: ng.translate.ITranslateService,
    navigate: Navigate,
    notificationManager: NotificationManager,
    session: Session,
    sessionManager: SessionManager,
  ) {
    const $ctrl = this;

    $ctrl.$onInit = () => {
      $ctrl.userName$ = session.current$.pipe(
        map((currentSession: CurrentSession) => currentSession.username),
      );

      $ctrl.availableTenants$ = session.current$.pipe(
        map(
          (currentSession: CurrentSession) => currentSession.availableTenants,
        ),
      );
    };

    $ctrl.setTenant = (tenant) => {
      if (!angular.isObject(tenant)) {
        return $q.reject(
          $translate.instant('gate.parameter_incorrect_type', {
            type: 'Object',
          }),
        );
      }

      if (!tenant.id) {
        return $q.reject(
          $translate.instant('gate.missing_reqired_parameter', { param: 'id' }),
        );
      }

      if (!tenant.name) {
        return $q.reject(
          $translate.instant('gate.missing_reqired_parameter', {
            param: 'name',
          }),
        );
      }

      return sessionManager.setTenant(tenant.id).then(
        () => {
          notificationManager
            .sendInfo(
              $translate.instant('gate.changed_tenant', tenant),
              'change-tenant',
              2000, // add lifetime of 2 seconds
            )
            .removePromise.then(navigate.back);
        },
        (error) => {
          notificationManager.sendInfo(error.message, 'set-tenant-error', 4000);

          // TODO add unit tests
          $timeout(() => {
            navigate.to('www', '/login', false);
          }, 4000);
        },
      );
    };
  },
});
